import { c as createModalInstance } from "../modal-61b9b77c.mjs";
import { d as defineVuesticPlugin } from "../../../services/vue-plugin/utils/define-vuestic-plugin-8c565dfe.mjs";
import { d as defineGlobalProperty } from "../../../services/vue-plugin/utils/global-properties-9524ee5b.mjs";
const createVaModalPlugin = (app) => ({
  init(options) {
    return createModalInstance(options, app == null ? void 0 : app._context);
  },
  confirm(options) {
    if (typeof options === "string") {
      return new Promise((resolve) => {
        createModalInstance({
          message: options,
          onOk() {
            resolve(true);
          },
          onCancel() {
            resolve(false);
          }
        }, app == null ? void 0 : app._context);
      });
    }
    return new Promise((resolve) => {
      createModalInstance({
        ...options,
        onOk() {
          var _a;
          (_a = options == null ? void 0 : options.onOk) == null ? void 0 : _a.call(options);
          resolve(true);
        },
        onCancel() {
          var _a;
          (_a = options == null ? void 0 : options.onCancel) == null ? void 0 : _a.call(options);
          resolve(false);
        }
      }, app == null ? void 0 : app._context);
    });
  }
});
const VaModalPlugin = defineVuesticPlugin(() => ({
  install(app) {
    defineGlobalProperty(app, "$vaModal", createVaModalPlugin(app));
  }
}));
export {
  VaModalPlugin as V
};
//# sourceMappingURL=index-675ea3b9.mjs.map
